import {formatDate} from '@angular/common';
import {Component, forwardRef, HostListener, Input, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonDatetime} from '@ionic/angular';
import {IonModal} from '@ionic/angular/directives/overlays/modal';
import {getBeforeYears} from 'src/app/domain/function/date.helper';
import {BaseInputComponent} from 'src/app/ui/shared/component/input/base-input.component';

type InputColor = 'primary' | 'secondary' | 'light' | 'dark' | 'grey';
type Type = 'adult' | 'child' | 'normal';

@Component({
  selector: 'app-datetime',
  template: `
    <app-form-input-decorator [formInput]="this">
      <ion-item color="transparent ion-no-padding ion-no-margin" lines="full"
                class="text-input-text"
      >
        <div class="flex flex-col justify-start items-start w-full">
          <div class="flex-1">
            <ion-label class="uppercase" position="stacked"><p class="text-base">{{ label }}</p></ion-label>
          </div>
          <div class="flex-1 pt-1 w-full">
            <ion-datetime-button datetime="datetime" class="hidden"></ion-datetime-button>
            <div>
              {{this.value | date:'dd/MM/yyyy'}}
            </div>
            <ion-modal [keepContentsMounted]="true" #datetimeModal>
              <ng-template>
                <ion-datetime
                  id="datetime"
                  presentation="date"
                  [showDefaultButtons]="true"
                  doneText="{{'shared.accept' | translate}}"
                  cancelText="{{'shared.cancel' | translate}}"
                  [firstDayOfWeek]="1"
                  (ionChange)=changeValue($any($event.target).value)
                  [value]="value"
                  [preferWheel]="true"
                  [max]="max()"
                  [min]="min()"
                  locale="es-ES"
                ></ion-datetime>
              </ng-template>
            </ion-modal>
          </div>
        </div>
      </ion-item>
    </app-form-input-decorator>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeComponent),
      multi: true,
    },
  ],
})

export class DateTimeComponent extends BaseInputComponent<string> {
  @ViewChild('datetime') datetime: IonDatetime;
  @Input() label = '';
  @Input() placeholder: string;
  @Input() readonly = false;
  @Input() type: Type = 'normal';
  @Input() color: InputColor = 'dark';
  @ViewChild('datetimeModal') modalDatetime: IonModal;
  @HostListener('click')

  public openCalendar(){
    this.modalDatetime.present();
  }

  public changeValue(value) {
    this.writeValue(value);
    this.onChange(value);
  }

  public max() {
    if (this.type === 'child') {
      return formatDate(new Date(), 'yyyy-MM-dd', 'en');
    }
    if (this.type === 'adult') {
      return formatDate(this.beforeEighteenYears(),'yyyy-MM-dd', 'en');
    }
  }

  public min() {
    if (this.type === 'child') {
      return formatDate(this.beforeEighteenYears(),'yyyy-MM-dd', 'en');
    }
  }

  public beforeEighteenYears(): Date{
    return getBeforeYears(18);
  }
}
